<template>
  <SettingEditLayout
    title="就業時間"
    summary="朝と夕方のお知らせは、ここで決めた時間を基準に届きます。"
    :fields="fields"
    :validate="validate"
  >
    <template #default="{ form }">
      <div class="hours-grid">
        <div>
          <label for="business-start">始業時刻<span class="required">必須</span></label>
          <CInput id="business-start" v-model="form.business_start_time" placeholder="09:00"/>
          <small>決めなければ09:00です。</small>
        </div>
        <div>
          <label for="business-end">終業時刻<span class="required">必須</span></label>
          <CInput id="business-end" v-model="form.business_end_time" placeholder="18:00"/>
          <small>決めなければ18:00です。</small>
        </div>
      </div>

      <div class="lead-grid">
        <div v-for="field in leadFields" :key="field.key">
          <label :for="'lead-' + field.key">{{ field.label }}</label>
          <CInput
            :id="'lead-' + field.key"
            v-model.number="form[field.key]"
            type="number"
            min="0"
            max="720"
          />
          <small>{{ field.description }}</small>
        </div>
      </div>

      <!--
        **前の日へ回り込む組み合わせは保存できない。**
        「本日の休暇予定」を前日の23時40分に送ると、中身は今日のものなのに
        届くのは昨日、という取り違えになる。サーバも同じところを見ている。
      -->
      <CAlert color="info" class="mt-3">
        既定のまま（始業09:00・終業18:00・30分／0分／30分）にしておくと、
        これまでどおり <b>8:30・9:00・17:30</b> に届きます。<br/>
        前倒しを長くしすぎて前の日に回り込む組み合わせは保存できません。
      </CAlert>
    </template>
  </SettingEditLayout>
</template>

<script>
import SettingEditLayout from '../SettingEditLayout.vue'
import { findSection } from '../settingSections'

const TIME_PATTERN = /^([0-9]|[01][0-9]|2[0-3]):[0-5][0-9]$/

export default {
  name: 'BusinessHoursEdit',
  components: { SettingEditLayout },

  data () {
    return {
      fields: findSection('business-hours').fields,
      leadFields: [
        {
          key: 'daily_schedule_notification_lead_minutes',
          label: '当日の休暇予定を、始業の何分前に送るか',
          description: '決めなければ30分前。管理部門とプロジェクトの両方に効きます。'
        },
        {
          key: 'pending_approval_notification_lead_minutes',
          label: '承認待ちのお知らせを、始業の何分前に送るか',
          description: '決めなければ0分（始業ちょうど）。'
        },
        {
          key: 'pending_leave_reminder_lead_minutes',
          label: '明日の未承認休暇を、終業の何分前に送るか',
          description: '決めなければ30分前。休業日でも送ります。'
        }
      ]
    }
  },

  methods: {
    validate (form) {
      const start = String(form.business_start_time || '').trim()
      const end = String(form.business_end_time || '').trim()
      if (!TIME_PATTERN.test(start)) return '始業時刻は「時:分」で入力してください。'
      if (!TIME_PATTERN.test(end)) return '終業時刻は「時:分」で入力してください。'

      for (const field of this.leadFields) {
        const value = form[field.key]
        if (value === '' || value === null || value === undefined) {
          return field.label + 'を入力してください。'
        }
        const minutes = Number(value)
        if (!Number.isFinite(minutes) || minutes < 0 || minutes > 720) {
          return field.label + 'は0〜720分で入力してください。'
        }
      }

      // **前の日へ回り込ませない。**画面で先に断る。
      // サーバも同じところを見ているが、往復を待たせない。
      const startMinutes = this.toMinutes(start)
      const lead = Math.max(
        Number(form.daily_schedule_notification_lead_minutes) || 0,
        Number(form.pending_approval_notification_lead_minutes) || 0
      )
      if (startMinutes - lead < 0) {
        return '始業の前倒しが長すぎて、前の日に回り込みます。'
          + ' 始業時刻を遅くするか、「始業の何分前に送るか」を短くしてください。'
      }
      return ''
    },

    toMinutes (text) {
      const parts = String(text).split(':')
      return Number(parts[0]) * 60 + Number(parts[1])
    }
  }
}
</script>

<style scoped>
.hours-grid,
.lead-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(16rem, 1fr));
  gap: 1rem;
  margin-top: 1rem;
}

label {
  display: block;
  font-weight: 600;
}

small { color: #5c6873; }

.required {
  margin-left: 0.4rem;
  padding: 0.1rem 0.4rem;
  border-radius: 0.2rem;
  background: #e55353;
  color: #fff;
  font-size: .75rem;
  font-weight: 600;
}
</style>
